module.exports = __webpack_public_path__ + "img/Arrow.cc9519dd.png";